"use client";
import { useCallback, useEffect, useMemo, useState } from "react";
import { DataTable } from "../../dataTables/data-table"
import { Button } from "@/components/ui/button";
import { Permissions, permissionsColumns } from "@/pages/permissions/PermissionsColumns";
import Spinner from "../spinnner/Spinner";
import CreatePermissionDrawer from "./CreatePermissionDrawer";
import { jwtDecode } from "jwt-decode"
import useAuth from "@/hooks/useAuth";
import UpdatePermissionDrawer from "./UpdatePermissionDrawer";
import { PermissionsDataTables } from "./PermissionsDataTables";
import { useLocation, useNavigate } from "react-router-dom";
import useAxiosPrivate from "@/context/UseAxiosPrivate";
import { errorNotification, successNotification } from "@/utils/Notification";


export default function PermissionsFn() {
    const [data, setData] = useState<Permissions[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [showPermissionDrawer, setShowPermissionDrawer] = useState(false);
    const [permissionData, setPermissionData] = useState<Permissions | undefined>(undefined)
    const [showUpdatePermissionDrawer, setShowUpdatePermissionDrawer] = useState(false);
    const { auth } = useAuth()
    const navigate = useNavigate();
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate();
    let token: any = auth.accessToken
    const decoded: any = jwtDecode(token);
    let roles: string[] = decoded.UserInfo.roles


    const getPermissions = () => {
        setLoading(true)
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/permissions', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: Permissions[]) => {
                if (isMounted) {
                    setData(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            }).finally(() => {
                setLoading(false)
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };





    useEffect(() => {
        getPermissions()
    }, []);



    const editFunctionCall = (permissions: Permissions) => {
        setPermissionData(permissions)
        setShowUpdatePermissionDrawer(!showUpdatePermissionDrawer)
    }


    const onEdit = useCallback(
        (permissions: Permissions) => editFunctionCall(permissions),
        []
    )


    const pemissionColumnsData = useMemo(() => permissionsColumns({ onEdit, roles }), [])

    if (loading) {
        return <Spinner />
    }

    return (
        <main className='mx-3 mt-16 sm:ml-[300px] sm:mt-3'>
            {roles.includes('permission-create') && (<Button
                variant='default'
                className="flex items-center justify-end"
                onClick={() => setShowPermissionDrawer(!showPermissionDrawer)}
            >
                Create Permission
            </Button>)}
            <PermissionsDataTables columns={pemissionColumnsData} data={data} filterNameColumn="uuid" />

            {roles.includes('permission-create') && (<CreatePermissionDrawer
                showPermissionDrawer={showPermissionDrawer}
                setShowPermissionDrawer={setShowPermissionDrawer}
                getPermissions={getPermissions}
            />)}

            {permissionData && roles.includes('permission-edit') && (
                <UpdatePermissionDrawer
                    setShowUpdatePermissionDrawer={setShowUpdatePermissionDrawer}
                    showUpdatePermissionDrawer={showUpdatePermissionDrawer}
                    permissions={permissionData}
                    getPermissions={getPermissions}
                    setPermissionData={setPermissionData}
                />
            )}

        </main>
    )
}